import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import { useGetConfigMutation } from "../../../api/services"
import "../assets/style.scss"
import { getCidParameter } from "@smpu-web/utils/utils"

const Notes = () => {
    const [campaignText, setCampaignText] = useState('')
    const [campaignDetailText, setCampaignDetailText] = useState('')

    const [getConfig] = useGetConfigMutation();
    let cidParameter = getCidParameter();
    useEffect(() => {
        if (cidParameter != null) {
            getConfig(`PosLead.CampaignText.Landing.Bottom.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        setCampaignText(payload.configValue)
                    }
                    else {
                        getConfig("PosLead.CampaignText.Landing.Bottom")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    setCampaignText(payload.configValue)
                                }
                            })
                    }
                })
            getConfig(`PosLead.CampaignText.Landing.Bottom2.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        setCampaignDetailText(payload.configValue)
                    }
                    else {
                        getConfig("PosLead.CampaignText.Landing.Bottom2")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    setCampaignDetailText(payload.configValue)
                                }
                            })
                    }
                })
        }
        else {
            getConfig("PosLead.CampaignText.Landing.Bottom")
            .unwrap()
            .then((payload) => {
                if (!payload.IsError) {
                    setCampaignText(payload.configValue)
                }
            })
            getConfig("PosLead.CampaignText.Landing.Bottom2")
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        setCampaignDetailText(payload.configValue)
                    }
                })
        }

    }, [getConfig])

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="notes-container accordion-container">
                <Block dangerouslySetInnerHTML={{ __html: campaignText }} />
                <List
                    accordion
                    accordionCollapsible
                    activeItem={0}
                    custom={false}
                    disabled={false}
                    expandOnlyOne
                    withPadding
                    withoutBorder={false}
                    className="campaign-list-title"
                >
                    <List.Item
                        accordion={false}
                        accordionCollapsible
                        disabled={false}
                        preventDefault
                        title="Kampanya Detayları"
                        withPadding={true}
                        className="campaign-list-item"
                    >
                        <Block dangerouslySetInnerHTML={{ __html: campaignDetailText }} />
                    </List.Item>
                </List>
            </Panel>
        </Page>
    )
}

export default Notes
